<template>
  <div class="diet-create-group">
    <v-alert v-if="status.type" fixed :type="status.type">{{status.mes}}</v-alert>
    <v-card class="item">
      <v-form ref="dietCreate" :lazy-validation="lazy" v-model="valid">
        <h3 class="mt-5 mb-5">{{updateDiet ? 'Editar dieta' : 'Cadastrar nova dieta' }}</h3>
        <v-text-field
          required
          v-model.trim="diet.title"
          type="text"
          :counter="20"
          label="Receita"
          :rules="titleRules"
        ></v-text-field>
        <v-text-field
          required
          type="number"
          v-model="diet.cal"
          label="Concentração calórica (kcal/mL)"
          :rules="calRules"
        ></v-text-field>
        <v-text-field
          required
          type="number"
          v-model="diet.protein"
          label="Concentração protéica (g/mL)"
          :rules="proteinRules"
        ></v-text-field>
        <v-btn
          :disabled="!valid"
          @click="store()"
          color="success"
        >{{updateDiet ? 'Atualizar dieta' : 'Cadastrar'}}</v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "appDietCreate",
  data() {
    return {
      valid: true,
      diet: {
        title: "",
        cal: "",
        protein: ""
      },
      titleRules: [
        v => !!v || "Título é obrigatório",
        v => (v && v.length <= 20) || "Não pode passar de 20 caracteres"
      ],
      calRules: [v => !!v || "Concentração calórica é obrigatório"],
      proteinRules: [v => !!v || "Concentração protéica é obrigatório"],
      lazy: false,
      status: {
        type: "",
        mes: ""
      },
      toUpdate: null
    };
  },
  props: {
    updateDiet: {
      default: null
    }
  },
  methods: {
    store() {
      if (this.updateDiet == null) {
        this.$store
          .dispatch("dietsBase/store", { diet: this.diet })
          .then(() => {
            this.status.mes = "Salvamos sua dieta :)";
            this.status.type = "success";
          })
          .catch(() => {
            this.status.mes = "Desculpe, não conseguimos salvar sua dieta";
            this.status.type = "error";
          })
          .finally(() => {
            setTimeout(() => {
              this.status.mes = "";
              this.status.type = "";
              this.$emit("toggleCreate");
            }, 2000);
          });
      } else {
        this.update();
      }
    },
    isUpdateDiet() {
      this.diet = this.updateDiet;
    },
    update() {
      this.$store
        .dispatch("dietsBase/update", {
          diet: this.diet
        })
        .then(() => {
          this.status.mes = "Atualizamos sua dieta :)";
          this.status.type = "success";
        })
        .catch(() => {
          this.status.mes = "Desculpe, não conseguimos atualizar sua dieta";
          this.status.type = "error";
        })
        .finally(() => {
          setTimeout(() => {
            this.status.mes = "";
            this.status.type = "";
            this.$emit("toggleCreate");
          }, 2000);
        });
    }
  },
  created() {
    if (this.updateDiet) {
      this.isUpdateDiet();
    }
  },
  destroyed() {
    this.$emit("cleanUpdateDiet");
  }
};
</script>

<style scoped>
.item {
  padding: 20px 10px;
}
</style>